"use client";
import React, { useCallback, useEffect, useState } from "react";
import stl from "../../styles/toast.module.scss";
import classnames from "classnames";
import { ExcludeT1FrT2 } from "../../interface";
import ReactDOM from "react-dom";
import { getGlobal } from "../../utils";
import FmLoading, { IProps as ILoadingProps } from "../FmLoading";
import { IToastProps } from ".";
type IVisible = {
    visible: ILoadingProps["visible"];
};

export type LoadingProps = ExcludeT1FrT2<ILoadingProps, IVisible>;
const defaultProps = {
    children: "",
    type: "info" as const,
    seconds: undefined, // seconds 秒后自动关闭toast
};

const useClientOnly = () => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    return isClient;
};

const Toast: React.FC<IToastProps> = (prop) => {
    const { onChange, ...props } = { ...defaultProps, ...prop };
    const [toastShow, setToastShow] = useState(props.visible);
    useEffect(() => {
        setToastShow(props.visible);
    }, [props.visible]);
    // n秒以后隐藏toast
    const hiddenToastByTimes = useCallback(
        (seconds: number) => {
            setTimeout(() => {
                setToastShow(false);
                onChange?.(false);
            }, seconds * 1000); // 几秒以后消失
        },
        [onChange],
    );

    // 监听是否有seconds
    useEffect(() => {
        if (props.seconds && props.seconds >= 0 && props.visible) {
            // seconds 不为undefined
            hiddenToastByTimes(props.seconds);
        }
    }, [hiddenToastByTimes, props.seconds, props.visible]);

    return (
        <div
            className={classnames(
                "container-mask",
                stl["container-mask"],
                {
                    ["hidden"]: !toastShow,
                },
                props.className,
            )}
            style={props.style}
        >
            <div
                className={classnames(
                    stl["toast-wrapper"],
                    "toast-wrapper",
                    stl[props.type], // info-default
                    props.className,
                    props.type,
                )}
            >
                {props.type === "info" ? (
                    props.children
                ) : (
                    <FmLoading
                        visible={toastShow}
                        text={props.children}
                        className={stl["margin-zero"]}
                    />
                )}
            </div>
        </div>
    );
};
const ToastClient: React.FC<IToastProps> = (props) => {
    const isClient = useClientOnly();
    const { onChange, ...rest } = props;
    useEffect(() => {
        // 因为有mask,意味着mask是不可点击，所以应该从html就禁止使用事件
        getGlobal().addEventListener("touch-start", (e: any) => {
            e.stopPropagation();
        });
        return () => {
            getGlobal().removeEventListener("touch-start", (e: any) => {
                e.stopPropagation();
            });
        };
    }, []);
    if (!isClient) {
        return null;
    }
    return ReactDOM.createPortal(
        <Toast {...rest} onChange={onChange} />,
        getGlobal().document.body,
    );
};

export default ToastClient;
